//1 )  representa lo que se va almacenar globalmente 
export const initialState = {
    usuario: {
        userId: '',
        nombreCompleto: '',
        email: '',
        userName: '',
        foto: '',
        defaultLanguage: '',
        companyId: ''
    },
    autenticado: false,
    tipoLogueo: '' /*Indica el tipo de logue Interno o SSO*/
}

//2) logica de como se va almacenar y manejar lo que se va guardar 
const sesionUsuarioReducer = (state = initialState, action) => {
    switch (action.type) {
        case "INICIAR_SESION":
            return {
                ...state,
                usuario: action.sesion,
                autenticado: action.autenticado,
                tipoLogueo: action.tipoLogueo
            };
        case "SALIR_SESION":
            return {
                ...state,
                usuario: action.nuevoUsuario,
                autenticado: action.autenticado,
                tipoLogueo: action.tipoLogueo
            };
        case "ACTUALIZAR_USUARIO":
            return {
                ...state,
                usuario: action.nuevoUsuario,
                autenticado: action.autenticado
            };
        default: return state;
    }
};


//3) Se exporta 
export default sesionUsuarioReducer;